import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';

export const useCompleteOnboarding = () => {
  const mfaData = useStore(state => state.mfaData);
  return useMutation(
    'useCompleteOnboarding',
    async () => {
      const res = await httpService.post(`${BASE_URL}/api/v3/onboarding/user/${mfaData?.customerId}/authorized/user/${mfaData?.authorizedExternalId}/complete`);
      return res.data;
    },
    {},
  );
};
